import React, {useEffect, useRef, useState} from 'react';
import styles from './Header.module.css';
import logoIcon from '../assets/icon/logo_icon.svg';
import logoText from '../assets/icon/logo_text.svg';
import langWorld from '../assets/icon/lang_world.svg';
import langArrowUp from '../assets/icon/lang_arrow_up.svg';
import langArrowDown from '../assets/icon/lang_arrow_down.svg';
import satAppButtonDwn from '../assets/icon/sat_app_button_dwn.svg';
import icDownload from '../assets/icon/ic_download.svg';
import satAppButtonDwnSmall from '../assets/icon/sat_app_button_dwn_small.svg';
import {useScreenDetector} from "../hooks/useScreenDetector";
import {useTranslation} from "react-i18next";


const Header: React.FC = () => {
    const {isMobile} = useScreenDetector();
    const {i18n, t} = useTranslation();

    const ref = useRef<HTMLDivElement>(null);
    const [isOpen, setIsOpen] = useState(false);

    const getLanguageCode = () => {
        const code = i18n.language;
        if (["kr", "ko"].includes(code.toLocaleLowerCase()))
            return "Ko";
        else if (["zh", "zh-cn"].includes(code.toLocaleLowerCase()))
            return "Zh";
        return "En";
    };
    const [lang, setLang] = useState(getLanguageCode());

    const handleChange = (code: any) => {
        setLang(code);
        switch (code) {
            case 'En':
                i18n.changeLanguage('en');
                break;
            case 'Zh':
                i18n.changeLanguage('zh');
                break;
            case 'Ko':
                i18n.changeLanguage('ko');
                break;
        }
        setIsOpen(false);
    }

    useEffect(() => {
        function handleClickOutside(event: MouseEvent): void {
            if (ref.current && !ref.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    });

    return (
        <div className={styles.header}>
            <nav className={styles.nav}>
                <div className={styles.logoContainer} onClick={() => {
                    window.open('https://satoshiapp.xyz', '_blank');
                }}>
                    <img
                        src={logoIcon}
                        className={styles.logo}
                    />
                    <img
                        src={logoText}
                        className={styles.logoText}
                    />
                </div>
                <div className={styles.navActions}>
                    <div className={styles.languageButton}>
                        {!isMobile && (
                            <img
                                src={langWorld}
                                className={styles.icon}
                            />
                        )}

                        <div className={styles.dropdown} ref={ref}>
                            <span>{lang}</span>
                            {isOpen && (
                                <div className={styles.dropdownContent}>
                                    <a href="#" onClick={() => handleChange('En')}>English</a>
                                    <a href="#" onClick={() => handleChange('Zh')}>简体中文</a>
                                    <a href="#" onClick={() => handleChange('Ko')}>한국어</a>
                                </div>
                            )}
                        </div>

                        <img
                            onClick={() => setIsOpen(!isOpen)}
                            src={isOpen ? langArrowUp : langArrowDown}
                            className={styles.icon}
                        />
                    </div>
                    <button className={styles.appButton}
                            onClick={() => {
                                window.open('https://satoshiapp.xyz/en/download-app', '_blank');
                            }}
                    >
                        <img className={styles.appButtonIcon} src={icDownload}/>
                        {!isMobile && (
                            <span className={styles.appButtonText}>{t('satoshiApp')}</span>
                        )}

                    </button>

                </div>
            </nav>
        </div>
    );
};

export default Header;